import React, {useRef, useContext, useEffect} from 'react';
import PropTypes from 'prop-types';

import {ProtocolEditorContext} from '../ContextProviders/ProtocolEditorContext';

import './TaskNumber.scss';

function TaskNumber({number, showArrow, isHighlighted, labwareId}) {
  const taskNumberRef = useRef(null);
  const protocolEditorContext = useContext(ProtocolEditorContext) || {};

  useEffect(() => {
    if (showArrow && protocolEditorContext && taskNumberRef) {
      const {setTaskNumberRefs} = protocolEditorContext;
      setTaskNumberRefs((prev) => ({...prev, [`${number}-${labwareId}`]: taskNumberRef}));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [number, taskNumberRef, labwareId]);

  return (
    <div ref={taskNumberRef} className={`task-number ${isHighlighted ? 'highlighted' : ''}`}>
      {number}
    </div>
  );
}

TaskNumber.propTypes = {
  number: PropTypes.any.isRequired,
  showArrow: PropTypes.bool,
  isHighlighted: PropTypes.bool,
  labwareId: PropTypes.any,
};

TaskNumber.defaultProps = {
  showArrow: false,
  isHighlighted: false,
  labwareId: '',
};

export default TaskNumber;
